import { GetBlogsResponse } from "model/response/blog/getBlogsResponse";
import { createBaseApiService } from "./baseApiService";
import { GetBlogBySlugRequest } from "model/request/blog/getBlogBySlugRequest";
import { GetBlogBySlugResponse } from "model/response/blog/getBlogBySlugResponse";
import { GetBlogsRequest } from "model/request/blog/getBlogsRequest";

export const createBlogService = () => {
  const baseService = createBaseApiService("/blog");

  const getBlogs = async (req: GetBlogsRequest) => {
    const response = await baseService.post<GetBlogsResponse>("/getBlogs", req);
    return response.data;
  };

  const getBlogBySlug = async (req: GetBlogBySlugRequest) => {
    const response = await baseService.post<GetBlogBySlugResponse | null>(
      "/getBlogBySlug",
      req,
    );
    return response.data;
  };

  return {
    getBlogs,
    getBlogBySlug,
  };
};
